import { defineStore } from 'pinia'

export type AIRPORT = 'VIE' | 'BER' | 'FRA' | 'HAM' | 'MUC' | 'STR' | 'MAD' | 'MXP' | 'FCO' | 'CIA' | 'TRN' | 'AMS' | 'CGN' | 'DUS'

const KNOWN_PLATFORM = ['KAYAK', 'SKYSCANNER', 'LILIGO']

export interface ReferralInfo {
  leadPlatform?: string
  leadGenerator?: string
  partnerBookingId?: string
  airport?: AIRPORT
  isFromReferral: boolean
  isMetaFlow: boolean
}

export const useReferralStore = defineStore('referral', {
  state: (): ReferralInfo => ({
    leadGenerator: undefined,
    leadPlatform: undefined,
    partnerBookingId: undefined,
    airport: undefined,
    isFromReferral: false,
    isMetaFlow: false,
  }),
  getters: {
    isPlatformKnown(): boolean {
      return this.leadPlatform
        ? KNOWN_PLATFORM.includes(this.leadPlatform?.toUpperCase())
        : false
    },
    logoLeadPlatform(): string | undefined {
      if (!this.isPlatformKnown) {
        console.warn(`Unknown referral (utm_medium url param): ${this.leadPlatform}`)
        return undefined
      }
      return `${useRuntimeConfig().public.imageURL}/logo/external/${this.leadPlatform}.svg`
    },
  },
})
